import { render, staticRenderFns } from "./SignatureGivenModal.vue?vue&type=template&id=1a2a1f44&"
import script from "./SignatureGivenModal.vue?vue&type=script&lang=js&"
export * from "./SignatureGivenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports